module.exports = __webpack_public_path__ + "static/img/9bg_1.fbe5532.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/9bg_1.png
// module id = 761
// module chunks = 1